import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { MarketHistoryEntity } from "./MarketHistoryEntity";
import { getMarketHistoryCount, setMarketHistoryCount } from "../helpers/ErrorCache";
import { MarketHistoryLatestEntity } from "./MarketHistoryLatestEntity";
import { HandleEsiError } from "../helpers/ErrorDisplayHelper";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedMarketHistoryEntity(
  regionID: number,
  typeID: number,
  latest_only?: boolean | number
): Promise<MarketHistoryEntity | MarketHistoryLatestEntity | null | string> {
  if (latest_only) {
    let entity: any = await cache.get("latest-" + typeID.toString() + "-" + regionID.toString());
    if (entity) {
      return entity;
    }
    const historyCount = parseInt(getMarketHistoryCount().toString());
    if (historyCount > 0) {
      try {
        setMarketHistoryCount(1);
        const alliance = await esiClient.get_markets_region_id_history(null, null, regionID, typeID);
        if (alliance !== null) {
          const otherEntity = new MarketHistoryEntity(typeID, regionID, alliance);
          cache.put(typeID.toString() + "-" + regionID.toString(), otherEntity, 6 * 60 * 60 * 1000 /* 6 hour */);
          entity = new MarketHistoryLatestEntity(typeID, regionID, alliance);
          cache.put("latest-" + typeID.toString() + "-" + regionID.toString(), entity, 6 * 60 * 60 * 1000 /* 6 hour */);
          return entity;
        } else {
          return null;
        }
      } catch (error) {
        HandleEsiError(error, undefined, "market_history");
        return null;
      }
    } else {
      return "limit";
    }
  } else {
    let entity: any = await cache.get(typeID.toString() + "-" + regionID.toString());
    if (entity) {
      return entity;
    }
    const historyCount = parseInt(getMarketHistoryCount().toString());
    if (historyCount > 0) {
      try {
        setMarketHistoryCount(1);
        const alliance = await esiClient.get_markets_region_id_history(null, null, regionID, typeID);
        if (alliance !== null) {
          const otherEntity = new MarketHistoryLatestEntity(typeID, regionID, alliance);
          cache.put(
            "latest-" + typeID.toString() + "-" + regionID.toString(),
            otherEntity,
            6 * 60 * 60 * 1000 /* 6 hour */
          );
          entity = new MarketHistoryEntity(typeID, regionID, alliance);
          cache.put(typeID.toString() + "-" + regionID.toString(), entity, 6 * 60 * 60 * 1000 /* 6 hour */);
          return entity;
        } else {
          return null;
        }
      } catch (error) {
        HandleEsiError(error, undefined, "market_history");
        return null;
      }
    } else {
      return "limit";
    }
  }
}
